import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import InvoiceOrdersPage from "../modules/InvoiceOrders/InvoiceOrdersPage";

export function InvoiceOrders() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "invoice-orders-page-title",
    defaultMessage: "Invoice orders"
  }));
  const subheader = useSubheader();
  subheader.setDisplaySubheader(false);

  return <InvoiceOrdersPage/>;
}
